import React, { useRef, useState } from 'react'

// redux
import { connect } from "react-redux";

// bootstrap
import { Spinner } from "react-bootstrap";

// icon
import { MdSearch, MdMenu, MdClear } from "react-icons/md";

// api
import { getProducts } from "utlis/Apis/Products_API";

// helpers | common
import {
    debounce,
} from "utlis/helpers/Common/CommonHelperFunctions";

// react router
import { useHistory } from "react-router-dom";

// react toastify
import { toast } from "react-toastify";

// react router
import { Link } from "react-router-dom";

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";

// no image
import noImgFoundImg from 'assets/images/no-img.png'

function Search(props) {
    // props
    const {
        commonToken,

        setMobileMenuVisibility
    } = props

    // refs
    const searchInp = useRef(null)

    // consts
    const history = useHistory();

    // states
    const [searchLoading, setSearchLoading] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [searchResultsImage, setSearchResultsImage] = useState([]);

    const [isMobileSearch, setIsMobileSearch] = useState(false);

    // search product
    const handleSearchProduct = debounce(ev => {
        const inpVal = ev.target.value
        console.log("inpVal ", inpVal);
        if (inpVal) {
            setSearchValue(inpVal)

            // enabling loading
            setSearchLoading(true)

            // generating url parameters
            let URLParams = `keyword=${inpVal}&page=1&limit=10`
            getProducts(commonToken ?? "", URLParams).then(res => {
                // disabling loading
                setSearchLoading(false)

                const resData = res.data
                // if request succesfull
                if (resData && resData.success) {
                    // settings products
                    setSearchResults(resData.data)

                    // settings images
                    const imagedObj = resData.images
                    setSearchResultsImage(imagedObj)
                }

                // if request is not succesfull
                if (resData && resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500,
                    });
                }
            }).catch(err => {
                console.log(
                    `${ERROR_WHILE__NAME} getProducts `,
                    err.message
                );

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // disabling loading
                        setSearchLoading(false)
                    },
                });
            })
        } else {
            // ressting data
            setSearchResults([])

            setSearchResultsImage([])
        }
    }, 200)

    const handleProductClick = (ev, link) => {
        ev.preventDefault()

        // ressting data
        searchInp.current.value = ""

        setSearchResults([])

        setIsMobileSearch(false)

        setSearchResultsImage([])

        // redirecting the home
        history.push(link)
    }

    return (
        <React.Fragment>
            {/* FOR MOBILE */}
            <div className="search-box-mobile d-flex align-items-center d-lg-none"> {/* HIDDEN ON LG */}
                {/* link */}
                <div className="sign-in-link position-relative d-flex align-items-center">
                    <MdSearch className="st-fs-21" onClick={ev => {
                        ev.preventDefault()

                        setIsMobileSearch(!isMobileSearch)
                    }} />
                </div>
                {/* link */}
                <div className="sign-in-link position-relative d-flex align-items-center">
                    <MdMenu className="st-fs-21" onClick={ev => {
                        ev.preventDefault()

                        setMobileMenuVisibility(true)
                    }} />
                </div>
            </div>

            {/* FOR LARGE SCREEN */}
            <div className={`search-box d-flex align-items-center ${isMobileSearch ? "active" : ""}`}>
                {/* input */}
                <input
                    type="text"
                    ref={searchInp}
                    placeholder="Search products"
                    defaultValue={searchValue}
                    onChange={handleSearchProduct}
                />

                {/* .icon */}
                <div className="d-flex">
                    <MdSearch className="icon cursor-pointer d-none d-lg-block" />

                    <MdClear className="icon cursor-pointer d-lg-none" onClick={ev => {
                        ev.preventDefault()

                        setIsMobileSearch(false)
                    }} />
                </div>
            </div>

            {
                (searchLoading || (searchResults?.length)) ? (
                    <div className="search-dropdown position-absolute">
                        <div className="inner position-relative">
                            {
                                /* item */
                                searchResults?.length ? searchResults.map(item => (
                                    <div key={item.product_id} className="item">
                                        <div onClick={(ev) => handleProductClick(ev, `/product/${item.product_url}?id=${item.product_id}`)} className="text-decoration-none inner d-flex align-items-center cursor-pointer">
                                            {/* img sec */}
                                            <div className="img-sec">
                                                <img
                                                    src={searchResultsImage[item.product_id]?.main_thumb?.small || noImgFoundImg}
                                                    onLoad={ev => ev.target.parentNode.classList.add("loaded")}
                                                    alt="" className="img-fluid" />
                                            </div>

                                            {/* text sec */}
                                            <div className="text-sec media-body st-fs-15 d-flex ps-3">
                                                <p className="p-name mb-0 st-fw-600">{item.product_name}</p>
                                                <p className="price ms-auto ps-2 st-fw-600 mb-0">$ {item.price.toFixed(2)}</p>
                                            </div>
                                        </div>
                                    </div>
                                )) : null
                            }

                            {
                                searchLoading ? (
                                    <div className="loading position-absolute h-100 w-100 d-flex align-items-center justify-content-center">
                                        <Spinner animation="border" />
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                ) : (
                    <React.Fragment>
                        {/* {<p>no result found</p>} */}
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}


const getDataFromStore = (state) => {
    return {
        commonToken: state.auth.commonToken,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {

    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(Search);